// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Element from "./element.js"
import ElementFeedbackOption from "./element-feedback-option.js"

const modelClassData = {
  "attributes": {
    "elaborate_answer": {
      "column": {
        "default": false,
        "name": "elaborate_answer",
        "null": false,
        "type": "boolean"
      },
      "name": "elaborate_answer",
      "selected_by_default": null,
      "translated": null
    },
    "element_id": {
      "column": {
        "default": null,
        "name": "element_id",
        "null": false,
        "type": "uuid"
      },
      "name": "element_id",
      "selected_by_default": null,
      "translated": null
    },
    "element_feedback_type": {
      "column": {
        "default": null,
        "name": "element_feedback_type",
        "null": false,
        "type": "string"
      },
      "name": "element_feedback_type",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    },
    "question": {
      "column": {
        "default": null,
        "name": "question",
        "null": true,
        "type": "string"
      },
      "name": "question",
      "selected_by_default": null,
      "translated": null
    },
    "translated_element_feedback_type": {
      "column": null,
      "name": "translated_element_feedback_type",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ElementFeedback",
  "collectionKey": "element_feedbacks",
  "collectionName": "element_feedbacks",
  "i18nKey": "element_feedback",
  "camelizedLower": "elementFeedback",
  "name": "ElementFeedback",
  "nameDasherized": "element-feedback",
  "pluralName": "element_feedbacks",
  "ransackable_associations": [
    {
      "className": "Element",
      "collectionName": "elements",
      "foreignKey": "element_id",
      "name": "element",
      "macro": "belongs_to",
      "resource_name": "Element",
      "through": null
    },
    {
      "className": "ElementFeedbackOption",
      "collectionName": "element_feedback_options",
      "foreignKey": "element_feedback_id",
      "name": "element_feedback_options",
      "macro": "has_many",
      "resource_name": "ElementFeedbackOption",
      "through": null
    },
    {
      "className": "FeedbackElement",
      "collectionName": "feedback_elements",
      "foreignKey": "element_feedback_id",
      "name": "feedback_elements",
      "macro": "has_many",
      "resource_name": "FeedbackElement",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Step",
      "collectionName": "steps",
      "foreignKey": "step_id",
      "name": "step",
      "macro": "has_one",
      "resource_name": "Step",
      "through": "element"
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "has_one",
      "resource_name": "Survey",
      "through": "step"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "elaborate_answer",
      "column": {
        "default": false,
        "name": "elaborate_answer",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "element_feedback_type",
      "column": {
        "default": null,
        "name": "element_feedback_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "element_id",
      "column": {
        "default": null,
        "name": "element_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_element_id",
      "column": {
        "default": null,
        "name": "old_element_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "position",
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "question",
      "column": {
        "default": null,
        "name": "question",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Element",
      "collectionName": "elements",
      "foreignKey": "element_id",
      "name": "element",
      "macro": "belongs_to",
      "resource_name": "Element",
      "through": null
    },
    {
      "className": "ElementFeedbackOption",
      "collectionName": "element_feedback_options",
      "foreignKey": "element_feedback_id",
      "name": "element_feedback_options",
      "macro": "has_many",
      "resource_name": "ElementFeedbackOption",
      "through": null
    }
  ],
  "paramKey": "element_feedback",
  "primaryKey": "id"
}

/** Frontend model for ElementFeedback. */
export default class ElementFeedback extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  elaborateAnswer() {
    return this.readAttributeUnderscore("elaborate_answer")
  }

  /** @returns {boolean} */
  hasElaborateAnswer() {
    const value = this.elaborateAnswer()

    return this._isPresent(value)
  }

  /** @returns {string} */
  elementId() {
    return this.readAttributeUnderscore("element_id")
  }

  /** @returns {boolean} */
  hasElementId() {
    const value = this.elementId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  elementFeedbackType() {
    return this.readAttributeUnderscore("element_feedback_type")
  }

  /** @returns {boolean} */
  hasElementFeedbackType() {
    const value = this.elementFeedbackType()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  question() {
    return this.readAttributeUnderscore("question")
  }

  /** @returns {boolean} */
  hasQuestion() {
    const value = this.question()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedElementFeedbackType() {
    return this.readAttributeUnderscore("translated_element_feedback_type")
  }

  /** @returns {boolean} */
  hasTranslatedElementFeedbackType() {
    const value = this.translatedElementFeedbackType()

    return this._isPresent(value)
  }

  /** @returns {import("./element.js").default | null} */
  element() {
    return this._readBelongsToReflection({modelClass: Element, reflectionName: "element"})
  }

  /** @returns {Promise<import("./element.js").default | null>} */
  loadElement() {
    if (!("elementId" in this)) throw new Error("Foreign key method wasn't defined: elementId")

    const id = this.elementId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "element",
        model: this,
        modelClass: Element
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./element.js").default | null>} */
  ensureElementLoaded() {
    return this.ensureAssociationLoaded("element")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./element-feedback-option.js").default>} */
  elementFeedbackOptions() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["element_feedback_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "element_feedback_options",
        model: this,
        modelClass: ElementFeedbackOption
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./element-feedback-option.js").default>>} */
  loadElementFeedbackOptions() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["element_feedback_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "element_feedback_options",
        model: this,
        modelClass: ElementFeedbackOption
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./element-feedback-option.js").default>>} */
  ensureElementFeedbackOptionsLoaded() {
    return this.ensureAssociationLoaded("element_feedback_options")
  }
}
